import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'TransformLinefeed' })
export class TransformLinefeedPipe implements PipeTransform {
  transform(value: string | undefined): string {
    if (typeof value === 'undefined') {
      return '';
    }

    return value.replace(/\r\n/g, '\n').replace(/\n/g, '<br />');
  }
}
